/** Rút gọn lỗi axios/DRF thành chuỗi hiển thị cho user. */
export function apiErrorMessage(error, fallback = "Thao tác thất bại") {
  const data = error?.response?.data ?? error?.data
  if (!data) return error?.message || fallback
  if (typeof data === "string") return data
  if (typeof data.detail === "string") return data.detail
  if (Array.isArray(data.detail)) {
    return data.detail
      .map((x) => (typeof x === "string" ? x : x?.msg || JSON.stringify(x)))
      .join("; ")
  }
  // EES style: { error: { code, message, details } }
  if (data.error && typeof data.error === "object") {
    if (typeof data.error.message === "string" && data.error.message) return data.error.message
    if (Array.isArray(data.error.details) && data.error.details.length) {
      return data.error.details
        .map((x) => (typeof x === "string" ? x : x?.message || JSON.stringify(x)))
        .join("; ")
    }
  }
  if (typeof data === "object") {
    for (const val of Object.values(data)) {
      if (typeof val === "string") return val
      if (val && typeof val === "object" && typeof val.message === "string") return val.message
      if (Array.isArray(val) && val.length) {
        const first = val[0]
        return typeof first === "string" ? first : first?.message || String(first)
      }
    }
  }
  return fallback
}
